import React from "react";
import {FieldTableCellProps, getTableCellStyle} from "../../../../render/table/table-cell";
import FieldFormula from "../../formula";
import {isBulkSelection} from "../../../../../gd/right-click-menu";

type State = {
    showPopover : boolean
}

export default class FieldFormula_TableCell extends React.Component<FieldTableCellProps, State>{

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            showPopover : false
        }
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    // is required for PopoverMenu to hide on click outside
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    render() {

        const field = this.props.field as FieldFormula

        const value = field.getDisplayValue(field.calculateValue(this.props.listItem.item))

        const classes = Classes("cell-flex ui5-field-editable ui5-txt-less-important-small")

        const prefix = _.get(field.components, 'ValuePrefix', null)

        return (
            <div className={classes} style={getTableCellStyle(this.props)} onClick={this.onClick}>
                <div className="max-w-100-percent txt-truncate">{prefix}{value}</div>

                {this.state.showPopover &&
                    <field.components.PopoverMenu
                        parent={this}
                        field={this.props.field}
                        // value={value}
                        model={this.props.listItem.item}
                    />
                }
            </div>
        )
    }
}
